// extracted by mini-css-extract-plugin
module.exports = {"meals":"AvailableMeals_meals__UkmyS","meals-appear":"AvailableMeals_meals-appear__2Bkuf"};